import React from "react";
import {
  MoonIcon,
  SunIcon,
  ComputerDesktopIcon,
} from "@heroicons/react/24/outline";
import useThemeStore from "../../utils/hooks/useThemeStore";

const DarkModeToggle = () => {
  const { theme, setTheme } = useThemeStore();

  const cycleTheme = () => {
    const next = {
      light: "dark",
      dark: "system",
      system: "light",
    };
    const newTheme = next[theme || "system"];
    setTheme(newTheme);
  };

  const iconMap = {
    light: <SunIcon className="size-5 text-gray-800" />,
    dark: <MoonIcon className="size-5 text-gray-300" />,
    system: <ComputerDesktopIcon className="size-5 text-blue-500" />,
  };

  return (
    <button
      onClick={cycleTheme}
      className="p-2 rounded-lg shadow-inner bg-gray-100 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700 transition-all"
      aria-label="Toggle Theme"
    >
      {iconMap[theme || "system"]}
    </button>
  );
};

export default DarkModeToggle;
